module.exports = __webpack_public_path__ + "img/warehouse.b70025db.png";